import { render, staticRenderFns } from "./ConfirmationCode.vue?vue&type=template&id=37a4e0f8&scoped=true&"
import script from "./ConfirmationCode.vue?vue&type=script&lang=ts&"
export * from "./ConfirmationCode.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmationCode.vue?vue&type=style&index=0&id=37a4e0f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a4e0f8",
  null
  
)

export default component.exports